import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { FILTER_BY } from '../../constant'
import {
  getSearchCompany,
  getSearchCompanyForPersonFilter,
  getSearchPerson,
} from './thunk'

const initialState = {
  filter: {
    filterBy: FILTER_BY.COMPANY,
    searchCompanyAndPerson: [],
    filterPerson: {},
    degree: 2,
  },
  loading: {
    widget: false,
    searchCompany: false,
    searchPerson: false,
    searchCompForPersonFilter: false,
  },
  listCompSearch: [],
  listPersonSearch: [],
  listCompSearchForPersonFilter: [],
}

const slice = createSlice({
  name: 'connectMap/interconnectionMap',
  initialState,
  reducers: {
    changeFilter: (state, action) => {
      state.filter = {
        ...state.filter,
        ...action.payload,
      }
    },
    changeListPersonSearch: (state, action) => {
      state.listPersonSearch = action.payload
    },
    resetState: (state) => {
      state.filter = initialState.filter
      state.loading = initialState.loading
      state.listCompSearch = initialState.listCompSearch
      state.listPersonSearch = initialState.listPersonSearch
      state.listCompSearchForPersonFilter =
        initialState.listCompSearchForPersonFilter
      state.compInfoDetail = initialState.compInfoDetail
    },
  },
  extraReducers: (builder) => {
    //search company
    builder.addCase(getSearchCompany.pending, (state) => {
      state.loading.searchCompany = true
    })
    builder.addCase(getSearchCompany.fulfilled, (state, action) => {
      state.listCompSearch = action.payload
      state.loading.searchCompany = false
    })
    builder.addCase(getSearchCompany.rejected, (state, action) => {
      state.loading.searchCompany = action.payload.loading
      state.listCompSearch = []
    })

    //search person
    builder.addCase(getSearchPerson.pending, (state) => {
      state.loading.searchPerson = true
      state.listPersonSearch = []
    })
    builder.addCase(getSearchPerson.fulfilled, (state, action) => {
      state.listPersonSearch = action.payload
      state.loading.searchPerson = false
    })
    builder.addCase(getSearchPerson.rejected, (state, action) => {
      state.loading.searchPerson = action.payload.loading
      state.listPersonSearch = []
    })

    //search company for person filter
    builder.addCase(getSearchCompanyForPersonFilter.pending, (state) => {
      state.loading.searchCompForPersonFilter = true
    })
    builder.addCase(
      getSearchCompanyForPersonFilter.fulfilled,
      (state, action) => {
        state.listCompSearchForPersonFilter = action.payload
        state.loading.searchCompForPersonFilter = false
      },
    )
    builder.addCase(
      getSearchCompanyForPersonFilter.rejected,
      (state, action) => {
        state.loading.searchCompForPersonFilter = action.payload.loading
        state.listCompSearchForPersonFilter = []
      },
    )
  },
})

export const selectFilter = (type) => (state) =>
  type ? state[slice.name].filter[type] : state[slice.name].filter
export const selectLoading = (type) => (state) =>
  state[slice.name].loading[type]
export const selectListCompSearch = (state) => state[slice.name].listCompSearch
export const selectListPeronSearch = (state) =>
  state[slice.name].listPersonSearch
export const selectListCompSearchForPersonFilter = (state) =>
  state[slice.name].listCompSearchForPersonFilter
export const selectCompanyInfoDetail = (state) =>
  state[slice.name].compInfoDetail

export const { changeFilter, changeListPersonSearch, resetState } =
  slice.actions

register(slice.name, slice.reducer)
